import { Videos } from '../_app/cuchillo/components/Videos';
import { Acordions } from '../_app/cuchillo/components/Acordions';
import { Basics, isDebug, isTouch } from '../_app/cuchillo/core/Basics';
import Forms from '../_app/cuchillo/forms/FormValidator';
import IconsHover from '../components/IconsHover';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Header from '../layout/Header';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Scene from '../3D/Scene';
import Cmp from '../windows/Cmp';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import AudioController from '../layout/AudioController';
import ScrollIndicator from '../layout/ScrollIndicator';
import { GetBy } from '../_app/cuchillo/core/Element';

export default class Default extends Page {
  constructor() {
    super();

    Videos.init();
    Acordions.init();
    Forms.init();
    IconsHover.init();

    // Import dinàmic: OpenLayers (1.15MB) només s'ha de baixar a les pàgines amb mapa,
    // no al bundle compartit per totes les pàgines (Default n'és la base).
    this._olMaps = null;
    if (GetBy.selector('[data-olmap]').length > 0) {
      import('../components/OLMaps').then(({ OLMaps }) => {
        this._olMaps = OLMaps;
        OLMaps.init();
      });
    }

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.addEventListener(Basics.clickEvent, Cmp._calls.click);
    });

    // Qualsevol block pot demanar que la seva pàgina no mostri el ScrollIndicator.
    this._noScrollIndicator = GetBy.selector('[data-no-scroll-indicator]', this.container).length > 0;
  }

  //SHOW
  beforeShow() {
    super.beforeShow();
    // Mateix tractament que el character: amaguem character i BGSphere a les pàgines Default.
    // Posar-ho aquí (i no a Home.beforeHide) garanteix que navegant Home↔Products es mantingui.
    Scene.hideCharacter();
    Scene.hideBGSphere();
    // Product: contingut molt llarg → mateix tractament que Home (veure Home.beforeShow):
    // wrapper/content = #Main/.wrap perquè el document es quedi congelat i iOS no
    // amagui/mostri la toolbar en fer scroll (_general.scss, body.page-product).
    // syncTouch + allowNestedScroll NOMÉS en touch, veure comentari a Home.beforeShow.
    Scroll.init(document.body.classList.contains('page-product')
      ? { wrapper: GetBy.id('Main'), content: GetBy.class('wrap')[0], syncTouch: isTouch, allowNestedScroll: true }
      : {});
    Keyboard.mountPage(this.id);

    if (this.isFirstTime) {
      Scene.start();
      WebGLSketch.start();
    }
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Preloader.directHide(() => {
        if (isDebug) {
          AudioController.directHide();
          Wrap.show(() => { this.afterShow(); });
        } else {
          AudioController.showLayer(() => {
            Wrap.show(() => { this.afterShow(); });
          });
        }
      });
    } else {
      Wrap.show(() => { this.afterShow(); });
    }
  }

  afterShow() {
    super.afterShow();
    WebGLSketch.enableRaycast();
    Header.enablePointer(); // reactiva el header per si venia desactivat (animació general)
    Scroll.start();
    Scroll.show();
    if (this.scrollIndicatorRatio > 0) ScrollIndicator.show();

    if (this.isFirstTime) {
      Header.show();
    }
  }

  //HIDE
  beforeHide() {
    WebGLSketch.disableRaycast();
    ScrollIndicator.hide();
    Keyboard.unmountPage(this.id);
    super.beforeHide();

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.removeEventListener(Basics.clickEvent, Cmp._calls.click);
    });
  }

  hide__effect() {
    Scroll.hide();
    Wrap.hide(() => { this.afterHide(); });
  }

  afterHide() {
    IconsHover.dispose();
    Scroll.dispose();
    if (this._olMaps) this._olMaps.dispose();
    super.afterHide();
  }

  //RESIZE
  resize() {
    super.resize();
    Scroll.resize();
    Acordions.resize();
  }

  // Fins on es veu el ScrollIndicator, en folds. Override per pàgina si cal (veure Home).
  // 0 = no es mostra mai (el flag es calcula un cop al constructor, no cada frame).
  get scrollIndicatorRatio() {
    return this._noScrollIndicator ? 0 : ScrollIndicator.HIDE_RATIO;
  }

  //LOOP
  loop() {
    // _isActive no es reseteja mai a false, i ControllerPage segueix fent loop() de la
    // pàgina sortint fins al disposeOut(). Sense _isHide (que Page._hide() posa a true
    // abans del beforeHide) la sortint continuaria manant sobre l'indicador durant la
    // transició: el Scroll.init() de l'entrant reseteja Scroll.y a 0 i el reactivaria.
    if (this._isActive && !this._isHide) {
      super.loop();
      ScrollIndicator.check(this.scrollIndicatorRatio);
    }
  }
}

ControllerPage._addPage('default', Default);
